<template>

    <div :id="tableContainerId" class="table_wrapper" :class="layoutType">

        <table class="table">
            <thead class="table_head">
                <slot name="tableHead"></slot>
            </thead>
            <tbody class="table_body">
                <slot name="tableBody" ></slot>
            </tbody>
            <tfoot>
                <slot name="tableFoot" ></slot>
            </tfoot>
        </table>

        <slot name="tableHelpers" ></slot>

    </div>

</template>

<script>
export default {
    name: 'TableWrapper',
    props: {
        tableContainerId: {
            type: String,
            required: true
        },
        layoutType: {
            type: String,
            required: false,
            default: "inline"
        }
    }
}
</script>

<style lang="scss">

.with_shadow{
    .table{
        box-shadow: rgb(0 0 0 / 10%) 0px 20px 25px -5px, rgb(0 0 0 / 4%) 0px 10px 10px -5px;
    }
}

.table_wrapper.inline{
    .table{
        width: 100%;
        border-radius: 8px;

        .table_head{
            font-weight: 600;
            color: $grey;
            text-transform: uppercase;
            th{
                height: $table-head-height;
                align-items: center;
            }
        }
        .table_body{
            tr{
                transition: .5s all;
                td{
                    height: $table-row-height;
                    padding-top: 12px;
                    padding-bottom: 12px;
                    vertical-align: middle;
                    &.icon_td{
                        max-width: 50px;
                        min-width: 50px;
                        width: 50px;
                        font-size: 1.2rem;
                        svg{
                            width: 22px;
                            fill: $grey-light;
                            transition: .3s all;
                        }
                        &:hover{
                            svg{
                                fill: $info;
                            }
                        }
                    }
                    &.with_dropslide{
                        overflow: hidden;
                    }
                    &.only_blocked{
                        display: none;
                    }
                    &.only_inline{
                        display: flex;
                    }
                }
                &.onDelete{
                    background: $danger;
                }
            }
        }
        .table-button{
            font-size: .9rem;
            font-weight: 500;
        }
        .padded_content{
            margin-left: 36px;
        }

    }
}
.table_wrapper.blocked{
    .table{
        width: 100%;
        .table_head{
            display: none;
        }
        .table_body{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            tr{
                width: calc(33.3333% - 16px);
                min-width: 430px;
                display: flex;
                flex-direction: column;
                margin:8px;
                border: 1px solid #ededed;
                border-radius: 8px;
                box-shadow: 2px 2px 6px #cecece;
                overflow: hidden;
                td{
                    height: $tableblocked-row-height;
                    padding: 0;
                    vertical-align: middle;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    padding-right: 15px;
                    &:before {
                        content: attr(data-label);
                        min-width: 120px;
                        max-width: 120px;
                        width: 120px;
                        padding-left: 10px;
                        text-transform: uppercase;
                        font-weight: bold;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        background: $light;
                        margin-right: 15px;
                        font-size: .85rem;
                    }
                    &.icon_td{
                        // padding-top: 24px;
                        // font-size: 1.2rem;
                        svg{
                            width: 30px;
                            fill: $grey-light;
                            transition: .3s all;
                        }
                        &:hover{
                            svg{
                                fill: $info;
                            }
                        }
                    }
                    &.with_dropslide{
                        overflow: hidden;
                    }
                    &:last-child{
                        border: none;
                    }
                    &.only_blocked{
                        display: flex;
                    }
                    &.only_inline{
                        display: none;
                    }
                }
                &:last-child{
                    td{
                        border-bottom: 1px solid $grey-light;
                    }
                }
                &.onDelete{
                    background: $danger;
                }
            }
        }
        .table-button{
            font-size: .9rem;
            font-weight: 500;
        }
        .padded_content{
            margin-left: 36px;
        }

    }
}
</style>